var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from "react";
import { BaseBlock, broadcastBlockLoad } from "sb-resp-block-lib";
import { BaseDict } from "./dict";
import { config } from "./config";
import { MyPulseBets } from "./MyPulseBets";
import { MyPulseBetsData } from "./data";
var _;
var PageMethodsMock;
var MasterEventsPageMethodsMock;
var BettingHistoryPageMethodsMock;
var BasePlayByPlayMock;
var UserInfoMock;
var BettingPageMethodsMock;
var OddsMock;
var _localMocks;
if (process.env.NODE_ENV === "development") {
    _ = require("sb-legacy-integration/lib-esm/mocks");
    _localMocks = require("../../mocks");
    PageMethodsMock = _.PageMethodsMock;
    MasterEventsPageMethodsMock = _localMocks.MasterEventsPageMethodsMock;
    BettingHistoryPageMethodsMock = _localMocks.BettingHistoryPageMethodsMock;
    BasePlayByPlayMock = _localMocks.BasePlayByPlayMock;
    UserInfoMock = _.UserInfoMock;
    OddsMock = _.OddsMock;
    BettingPageMethodsMock = _localMocks.BettingPageMethodsMock;
}
var MyPulseBetsRoot = /** @class */ (function (_super) {
    __extends(MyPulseBetsRoot, _super);
    // constructor sets defaults
    function MyPulseBetsRoot(domId, options) {
        if (options === void 0) { options = {
            dict: BaseDict,
            cms: {},
            navHandler: {},
            dataProvider: {},
            betSlipUtil: {},
            oddsUtil: {},
            facade: {}
        }; }
        var _this = _super.call(this, domId, options) || this;
        if (process.env.NODE_ENV === "development") {
            // setup data mocks for debug build
            _this.dataProvider = new MyPulseBetsData({
                pageMethods: new PageMethodsMock(),
                masterEventsPageMethoods: new MasterEventsPageMethodsMock(),
                bettingHistoryPageMethods: new BettingHistoryPageMethodsMock(),
                basePlayByPlay: new BasePlayByPlayMock(),
                bettingPageMethods: new BettingPageMethodsMock(),
                userInfo: UserInfoMock
            }, new OddsMock(), BaseDict, config);
            // setup dictionary for debug build
            _this.options.dict = BaseDict;
            //export data store to window for debug purposes
            window["MyPulseBetsDATA"] = _this.dataProvider;
        }
        // if no provided dictionary is not full fill in the missing keys with the base one
        _this.options.dict = __assign({}, BaseDict, (options.dict || {}));
        _this.options.cms = __assign({}, config, (options.cms || {}));
        if (process.env.NODE_ENV === "production" && typeof options.dataProvider !== "undefined") {
            // use pagemethods passed during the construction from the
            // mobile application
            _this.dataProvider = new MyPulseBetsData(options.dataProvider, options.oddsUtil, _this.options.dict, _this.options.cms);
        }
        return _this;
        // merge default and CMS options
    }
    MyPulseBetsRoot.prototype.activate = function () {
        return _super.prototype.activate.call(this, React.createElement(MyPulseBets, { dataProvider: this.dataProvider, dict: this.options.dict }));
    };
    return MyPulseBetsRoot;
}(BaseBlock));
export { MyPulseBetsRoot };
window["MyPulseBets"] = MyPulseBetsRoot;
broadcastBlockLoad("MyPulseBets");
//# sourceMappingURL=index.js.map